import './App.css';
import React from "react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import PrivacyForm from "@/pages/PrivacyForm";

export default function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>Privacy & Data Opt-Out</title>
      </Helmet>
      <main>
        <PrivacyForm />
      </main>
    </HelmetProvider>
  );
}
